import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ItineraryState = {
  itineraries: any | null | undefined
}



const initialState: ItineraryState = {
  itineraries: undefined
}

export const itinerarySlice = createSlice({
  name: 'itineraries',
  initialState,
  reducers: {
    setItinerariesStore(state, action: PayloadAction<any[] | null>) {

      //iterating through the array of itineraries and add the name in lowercase, its throwing nameLowerCase is read only
      state.itineraries = action.payload?.map((itinerary) => {
          return {
              ...itinerary,
              nameLowerCase: itinerary.name.toLowerCase()
          }
      })
    }
  }
})

export const { setItinerariesStore } = itinerarySlice.actions

export default itinerarySlice.reducer
